export const en = {
    support_chat: 'support chat',
    support_chat_first_letter_uppercase: 'Support chat',
};
